import React from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
//@ts-ignore
import logo from "../../assets/logo-white.png";

export const PlayResponsibly = () => {
  document.title = "Casino24 - Prompting Reasonable and Safe Gambling";
  return (
    <Container
      fluid
      className="m-0 flex flex-col min-h-full w-full items-center text-white"
    >
      <section className="w-full lg:w-[75%] lg:mt-[2rem] mb-1">
        <Link to="/">
          <img
            src={logo}
            alt="Casino24"
            className="object-cover w-[10rem] lg:w-[15rem] my-3 cursor-pointer"
          />
        </Link>
      </section>
      <section className="flex flex-col w-[90%] lg:w-[50%] xl:w-[37%] my-2 text-justify text-md ">
        <h2 className="text-center font-bold text-2xl xl:text-3xl mt-4">
          Responsible Gaming
        </h2>
        <p className="mb-5 mt-5">
          Understanding the term responsible gambling starts by knowing the
          meaning of the word responsible. It means to have control over
          something or to be accountable, most of all it means you have the
          power to manage the situation. Responsible gambling involves a range
          of social initiatives set by the gaming control boards and
          governments. The goal is not only to promote awareness of problem
          gambling but to ensure fairness and integrity.
        </p>
        <p className="mb-5">
          Gambling is one of the most fun forms of entertainment when you enjoy
          it responsibly. The characteristics of a responsible gambler are to
          set limits on the amount he/she spends on gambling. Your budget should
          only include the money you can afford to lose. Drinking or using drugs
          could cloud your decision-making during gambling, which means it
          should be avoided at all costs.
        </p>
        <p className="mb-5">
          It is a form of entertainment, which means you should stay away from
          it if you are upset or depressed. If you start gambling more than you
          can afford, you know it is time to take a break. Only when you can
          exercise control over your activity and not allow it to have any
          negative impact on your life. You can claim that you gamble
          responsibly.
        </p>
        <p className="mb-5 font-bold">
          Problem Gambling & Reasons Why People Gamble
        </p>
        <p className="mb-5">
          Before you can set off on a road to recovering from problem gambling,
          you need to understand why you gamble. The most common reason is to
          win money, many see gambling as an opportunity to overcome debt. Often
          it is seen as entertainment that also offers you the option of making
          a profit. The biggest motivation is the dream of hitting a big win.
          Often the biggest encouragement is financial difficulties, which makes
          people gamble with the hope of winning.
        </p>
        <p className="mb-5">
          There are also thousands of gamblers that want to escape from their
          real-life problems. Problem gamblers see gambling as an opportunity to
          get away from negative feelings or depression. In many cases, people
          actually gamble due to loneliness or boredom.
        </p>
        <p className="mb-5">
          Gambling, whether it is land-based or online offers players excitement
          and stimulation. The spinning or gaming action is often a great form
          of escapism. It gives players a high that is equal to alcohol or drug
          use, it is called feeling lucky.
        </p>
        <p className="mb-5 font-bold">
          Responsible Behaviour = Responsible Gambling
        </p>
        <p className="mb-5">
          The words responsible behaviour means considering the consequences of
          our actions. It means doing the right thing even when it is not easy.
          When you think of anyone you would call responsible, it will be the
          person you know you can count on. It is the person you can trust to
          always be there and to always do the right thing. We all want to be
          that person to others, and we can be if we follow the recipe.
        </p>
        <p className="mb-5">
          If you want to be responsible you need to blend five ingredients,
          these include fairness, accountability, honesty, courage, compassion
          or respect. Even when you do get away with a white lie, in the end,
          honesty remains the best policy. We all want others to appreciate us,
          understand us and accept us and most of all respect us. If your honest
          and respect others, you will enjoy their respect. If you are
          accountable for your share of work and never make excuses, you can
          expect fairness. Should you fail on any of the above, you’ll need the
          courage to do the right thing, which is asking for help.
        </p>
        <p className="mb-5">
          Responsible behaviour not only means that your actions are
          appropriate, but you also finish your tasks on time and always tell
          the truth. But also, that you happily follow all rules and is not
          afraid to admit your mistakes.
        </p>
        <p className="mb-5 font-bold">Reality Check</p>
        <p className="mb-5">
          One thing is for certain and that is than none of us do the right or
          correct thing always. It is often really challenging to do what is
          right and therefore we often make mistakes. You know before anyone
          else when something is just not right or spinning out of control. When
          this happens, it is time for a reality check, and you need to sit down
          and answer a few questions. There are actually a few options, you can
          either cut down on gambling, completely stop or find help.
        </p>
        <p className="mb-5">
          One of the first questions is can you afford to gamble and spend the
          amount of money you do. If your answer is no, it is time to take
          control and to make changes.
        </p>
        <p className="mb-5">
          If you have already tried to stop or cut down on your gambling before,
          you know what is involved in cutting down. It might take a few tries
          to stop, but it is always easier when you have support. Find another
          activity to take the place of gambling, which might help you to resist
          the urges.
        </p>
        <p className="mb-5">
          One of the most important questions to answer truthfully is the impact
          gambling have on your life. This includes the impact on your family,
          work, emotional wellbeing and relationships. There are two routes you
          can follow to change your situation depending on the severity of the
          problem. You can either cut down on gambling or quit. Regardless of
          the option you choose, there are quite a few ways to achieve success.
        </p>
        <p className="mb-5 font-bold">Self Help Options</p>
        <p className="mb-5">
          The options to cut down on your gambling habit includes setting a
          timeframe. Give yourself a month and then check on your progress, if
          you did cut down, you’re on the right track. If not, you might
          consider quitting or calling in the help of a friend.
        </p>
        <p className="mb-5">
          To limit your gambling, you could set a time on how long your session
          should last. You also need to set a limit on how much you gamble and
          never go over your budget. It is good to share your decision with
          others and to slowly replace gambling with another interest or
          activity. But, when all these fails, you will know that there is only
          one way out and that is to quit gambling completely.
        </p>
        <p className="mb-5">
          Deciding to stop any habit, whether it is smoking, or gambling
          requires great willpower. It is challenging and even when it feels
          impossible, it is much easier to quit when you have others helping
          you. Alone it is easier to fall back into your habit if you have the
          help of others you can get through the urges. You need to stay away
          from anything that triggers your gambling urges. If possible, avoid
          any situation that reminds you of gambling.
        </p>
        <p className="mb-5">
          There are a few ways to prevent yourself from gambling, stay calm and
          refocus. Watch television, read a book, bake something or go for a
          long walk. Call a friend or go out for coffee on your own, remember
          the urges do get less.
        </p>
        <p className="mb-5">
          To stay focussed on quitting you can set a goal and use the money you
          would’ve gambled towards a dream holiday. Think how proud your friends
          and family will be and how easily you’ll be able to settle any bills.
        </p>
        <p className="mb-5 font-bold">Helplines</p>
        <p className="mb-5">
          Quitting is challenging and you should feel proud of yourself for
          identifying the need to seek help. There are many helplines available
          worldwide to offer you the assistance you need 24 hours a day.
        </p>
        <p className="mb-5">
          National Council on Problem Gambling offers a list of international
          help contacts. Founded in 1972, the NCPG offers assistance to gamblers
          and their families to overcome the effects of problem gambling. These
          include websites and telephone numbers for Australia, Canada, Austria,
          Norway, South Africa and Switzerland, to list only a few.
        </p>
        <p className="mb-5">
          The National Gambling Helpline is always available, whether its day or
          night you have access to help via GamCare. Support is available 24/7
          to anyone suffering from gambling addiction. Assistance is also
          available to anyone suffering because of the effects on gambling
          problems.
        </p>
        <p className="mb-5">
          BeGambleAware offers free assistance to anyone who is concerned about
          a family member or friend with gambling problems. You can access help
          via live chat or telephone at any time of the day or night.
        </p>
      </section>
    </Container>
  );
};
